import React from 'react';
import { Box, Typography } from '@mui/material';

const shortcuts = [
  { keys: '↑ ↓', action: 'vælg' },
  { keys: 'Enter', action: 'åbn' },
  { keys: 'Ctrl+Enter', action: 'åbn i nyt vindue' },
  { keys: 'Esc', action: 'luk' },
  { keys: 'Ctrl+Mellemrum', action: 'åbn/luk' },
];

export function OmnibarKeyboardHelp() {
  return (
    <Box sx={{ px: 2, py: 1, borderTop: theme => `1px solid ${theme.palette.divider}` }} aria-label="Tastaturgenveje">
      <Typography variant="caption" color="text.secondary">
        {shortcuts.map((shortcut, index) => (
          <React.Fragment key={shortcut.keys}>
            {index > 0 && ' · '}
            <Box component="kbd" sx={{ fontFamily: 'inherit', fontWeight: 600 }}>
              {shortcut.keys}
            </Box>{' '}
            {shortcut.action}
          </React.Fragment>
        ))}
      </Typography>
    </Box>
  );
}
